import storeInfo from 'ducks/store'
import { PropertyActivity } from 'ducks/types'

export const getPropertyActivity = () => (): PropertyActivity => {
  const { propertyActivity } = storeInfo.store.getState()
  return propertyActivity
}
